<div class="video-processing-card" role="status" aria-live="polite">
  <h3 class="video-processing-card__title">{{ title }}</h3>
  <p class="video-processing-card__message">{{ message }}</p>
  <button
    *ngIf="showRefresh"
    type="button"
    class="video-processing-card__refresh"
    (click)="onRefresh()"
  >
    Refresh
  </button>
</div>
